import axios from "axios";
import { API_BASE_URL, API_PASSWORD } from "./apiConfig"; // 👈 استدعاء

// إعداد Axios
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});



export const attachFeatureToPlane = (data) => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return api.post(
    `attach/featuer/plane?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// ✅ استدعاء الخصائص (Features)
export const getAllFeatures = async () => {
  const token = localStorage.getItem("authToken");
  const response = await api.get(`get/featuers?api_password=${API_PASSWORD}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return response.data; // ✅ بدل ما ترجع response كله
};

export const attachFeatureToTenant = (tenant_id, data) => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    formData.append(key, value);
  });
  return api.post(
    `add/feature/to/tenant/${tenant_id}?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteFeatureFromTenant = (tenant_id, feature_id, plane_id) => {
  const token = localStorage.getItem("authToken");
  const url = `delete/feature/from/tenant/${tenant_id}/${feature_id}?api_password=${API_PASSWORD}`;
  const formData = new FormData();
  if (feature_id) formData.append("feature_id", feature_id);
  if (plane_id) formData.append("plane_id", plane_id);
  return api.get(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    data: formData,
  });
};

export const removeFeatureFromPlane = (plane_id, feature_id) => {
  const token = localStorage.getItem("authToken");
  const formData = new FormData();
  formData.append("feature_id", feature_id);
  formData.append("plane_id", plane_id);
  return api.post(
    `remove/featuer/plane?api_password=${API_PASSWORD}`,
    formData,
    {
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

